import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledLoadMoreButton = styled.button`
  width: 100%;
  max-width: 310px;
  margin: 20px auto;
  padding: 14px 24px;
  background: linear-gradient(
    135deg,
    ${colors.gradientBlue} 0%,
    ${colors.gradientTeal} 100%
  );
  border: none;
  border-radius: 70px;
  color: white;
  font-size: 15px;
  font-weight: 500;
  font-family: "Noto Sans Hebrew", sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 78, 247, 0.2);
  display: block;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 78, 247, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  &:focus {
    outline: none;
    box-shadow: 0 2px 8px rgba(0, 78, 247, 0.2);
  }

  &:focus-visible {
    outline: 2px solid ${colors.gradientBlue};
    outline-offset: 2px;
  }

  .loading-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    direction: rtl;
  }

  .spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .button-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .count-info {
    font-size: 13px;
    opacity: 0.85;
    font-weight: 400;
    margin-top: 2px;
  }

  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 14px;
    margin: 16px auto;
    max-width: 280px;

    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &:focus {
      outline: none !important;
      box-shadow: 0 2px 8px rgba(0, 78, 247, 0.2) !important;
    }
  }
`;
